var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87823",
    "data-name": "Group 87823",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14977",
    "data-name": "Rectangle 14977",
    width: 27,
    height: 27,
    rx: 7,
    fill: "#cef4e8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user",
    "data-name": "Icon awesome-user",
    d: "M6.973,7.969A3.985,3.985,0,1,0,2.988,3.985,3.984,3.984,0,0,0,6.973,7.969Zm2.789,1h-.52a5.419,5.419,0,0,1-4.539,0h-.52A4.185,4.185,0,0,0,0,13.149v1.3a1.5,1.5,0,0,0,1.494,1.494H12.452a1.5,1.5,0,0,0,1.494-1.494v-1.3A4.185,4.185,0,0,0,9.762,8.965Z",
    transform: "translate(6.527 5.531)",
    fill: "#0ccda5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUserIcon);
export default __webpack_public_path__ + "static/media/new_user_icon.06bcf7f9.svg";
export { ForwardRef as ReactComponent };